<template></template>

<script>
const eventProcessor = {
  add_to_cart: ({ ticketBlock, ticketGroup, kit }) => ({
    event: "add_to_cart",
    data: {
      items: [ticketBlock.id],
      name: ticketBlock.name,
      type: "ticket",
      value: ticketBlock.price + (ticketGroup.fee || 0),
      currency: "BRL",
    },
  }),
  initiate_checkout_shop: ({ amount, cart }) => ({
    event: "initiate_checkout_shop",
    data: {
      items: [...Object.keys(cart)],
      num_items: Object.values(cart).reduce(
        (acc, { quantity }) => acc + quantity,
        0
      ),
      value: amount,
      currency: "BRL",
    },
  }),
  initiate_checkout: ({ amount, Tickets = [] }) => ({
    event: "initiate_checkout",
    data: {
      items: Tickets.map(({ id }) => id),
      num_items: Tickets.length,
      value: amount,
      currency: "BRL",
    },
  }),
  purchase: ({ amount, paymentId, Tickets = [], paymentType, paymentMethod }) => ({
    event: "purchase",
    data: {
      paymentId,
      paymentMethod,
      paymentType,
      num_items: Tickets.length,
      items: Tickets.map(({ id }) => id),
      value: amount,
      currency: "BRL",
    },
  }),
};

export default {
  name: "PosthogEventListener",
  props: {},

  beforeDestroy() {
    this.removeEventsListeners();
  },
  methods: {
    removeEventsListeners() {
      for (var event of Object.keys(eventProcessor)) {
        this.$root.$off(event, this.emit(event));
      }
    },
    emit(type) {
      return (d) => {
        if (eventProcessor[type]) {
          const { event, data } = eventProcessor[type](d);
          console.log("Posthog event", event, data);
          this.$posthog.capture(event, data);
        }
      };
    },
  },
  mounted() {
    for (var event of Object.keys(eventProcessor)) {
      this.$root.$on(event, this.emit(event));
    }
  },
};
</script>

<style></style>
